import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useLottie } from 'lottie-react';
import checkAnimation from '../../assets/Animations/Success-300x300.json';
import { redirect } from '../../utils/redirect';
import AppStateContext from '../../AppStateProvider/context';
import { complete } from '../../utils/complete';
import addParam from '../../utils/addParam';
import { encodeString } from '../../utils/encoding';


export default function Final() {
	const { t, i18n } = useTranslation();
	const { state } = useContext(AppStateContext);
	const completeState = complete(state);
	const { View } = useLottie({
		animationData: checkAnimation,
		loop: false,
		className: 'animation',
		onComplete: () => {
			if (completeState) redirect();
		},
	});

	if (!completeState) {
		return (
			<div className='top'>
				<div className='final'>
					<h1>{t('FinalErrorHeadline')}</h1>
					<p className='p1'>{t('FinalErrorText')}</p>
				</div>
			</div>
		);
	}


	const setupToStore = {
		brand: state.brand,
		market: state.market,
		password: encodeString(state.password),
		userPassword: encodeString(state.userPassword),
		device: state.device,
		language: i18n.language,
		label: state.goToLabel,
		pinpairingActivationResponse: state.pinpairingActivationResponse,
		clientId: `${state.market?.prodUrl || 'unknown'}_${state.device || 'device'}`,
		preview: state.preview,
		show_second_screen: state.show_second_screen,
		orientation: state.orientation,
		pairing: state.pairing
	};

	try {
		localStorage.setItem('setup', JSON.stringify(setupToStore));
	} catch (e) {

		console.error('[Final] Error while writing setup in LS', e);
	}

	if (state.apk) {
		const rotationMap: Record<'default' | 'right' | 'down' | 'left', string> = {
			default: '0',
			right: '90',
			down: '180',
			left: '270',
		};

		const params = new URLSearchParams(window.location.search);
		const orientation = (params.get('orientation') as 'default' | 'right' | 'down' | 'left') || 'left';
		const rotationValue = rotationMap[orientation];
		const umdaschVersion = params.get('device-type') || 'UmdaschV1';

		const accountContent = [
			'id=' + (state.device ?? ''),
			'language=' + (state.language || i18n.language),
			'umdasch_version=' + umdaschVersion,
			'secondscreen_rotation=' + rotationValue,
			'migration=' + 'true'
		].join('\n');

		addParam('account', accountContent, true);

		const element = document.createElement('a');
		const file = new Blob([accountContent], { type: 'text/plain' });
		element.href = URL.createObjectURL(file);
		element.download = 'account.ini';
		document.body.appendChild(element);
		element.click();
		document.body.removeChild(element);
	}

	return (
		<div className='top'>
			<div className='final'>
				{!state.preview && (
					<>
						<h1>{t('FinalHeadline')}</h1>
						<p className='p1'>{t('FinalText')}</p>
					</>
				)}
				<>{View}</>
			</div>
		</div>
	);
}
